import {defaultLocaleId} from '@local/config/locales.mjs'
import {NextRequest} from 'next/server'

const VERCEL_BRANCH_URL = process.env.VERCEL_BRANCH_URL || process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
const VERCE_HASH_URL = process.env.VERCEL_URL || process.env.NEXT_PUBLIC_VERCEL_URL

export const VERCEL_URL = 'https://' + (process.env.NEXT_PUBLIC_DOMAIN || VERCE_HASH_URL || VERCEL_BRANCH_URL)
export const baseUrl = typeof window !== 'undefined' ? window.location.origin : process.env.NODE_ENV === 'development' ? `http://localhost:${3000}` : VERCEL_URL

export interface NextFetchRequestConfig {
	revalidate?: number | false
	tags?: string[]
}

export interface FetchOptions {
	next?: NextFetchRequestConfig | undefined
	cache?: globalThis.RequestInit['cache']
}

export interface GetOptions extends globalThis.RequestInit, FetchOptions {
	locale?: string
	injectLocaleAsParam?: boolean
	searchParams?: object
}

export const get = (url, options: GetOptions = {}) => {
	const {locale = defaultLocaleId, injectLocaleAsParam = false, searchParams, body, ...rest} = options
	const targetUrl = new URL(baseUrl + url)

	if (injectLocaleAsParam && locale) {
		targetUrl.searchParams.append('locale', locale)
	}

	if (searchParams) {
		for (const key in searchParams) targetUrl.searchParams.append(key, searchParams[key])
	}

	return fetch(targetUrl.toString(), {
		method: options.method || 'GET',
		headers: {
			'Content-Type': 'application/json',
			...(locale && {'Accept-Language': locale.toUpperCase()}),
		},
		body: body ? JSON.stringify(body) : undefined,
		...(rest || {}),
	}).then(d => d.json())
}

export const post = (url, body?, options: any = {}) => {
	return get(url, {...options, method: 'POST', body})
}

export const getParams = (req: NextRequest) => {
	const urlSearchParams = new URLSearchParams(req.nextUrl.search)
	const params = Object.fromEntries(urlSearchParams.entries())
	return params
}

export const getIPReq = request => request?.ip || request?.headers?.['x-forwarded-for'] || request?.headers?.['x-real-ip'] || request?.connection?.remoteAddress
export const getIPHeaders = headers => headers?.get('ip') || headers?.get('x-forwarded-for') || headers?.get('x-real-ip')
export const getIP = (request, headers) => getIPReq(request) || getIPHeaders(headers)
